import api from "@/lib/api";

// Store builds only. Reached through the Capacitor runtime on the window, so the web bundle never
// needs the native plugin as a dependency. Android keeps using web push, which a Play TWA delivers
// even when the app is closed; this is what an iPhone build needs instead.
const plugins = () => (typeof window === "undefined" ? null : window.Capacitor?.Plugins || null);

export const isNativeApp = () => Boolean(plugins()?.PushNotifications);

export const registerNativePush = async (scope) => {
  const push = plugins()?.PushNotifications;
  if (!push) return false;
  try {
    let status = await push.checkPermissions?.();
    if (status?.receive !== "granted") status = await push.requestPermissions();
    if (status?.receive !== "granted") return false;
    const info = await plugins()?.App?.getInfo?.().catch(() => null);
    await push.addListener("registration", async ({ value }) => {
      try {
        await api.post("/push/native/register",
          { token: value, scope, platform: "ios", app_id: info?.id || "" });
      } catch (e) {
        console.warn("could not register this device for push", e);
      }
    });
    await push.register();
    return true;
  } catch (e) {
    console.warn("native push unavailable", e);
    return false;
  }
};
